module.exports = __webpack_public_path__ + "img/8.be05cb09.jpg";